import React from 'react';

const chipStyle = {
    display: 'flex',
    height: '20px',
    padding: '0px 12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    borderRadius: '20px',
    background: '#75C422',
    color: '#333',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px',
};

const BasicChip = ({ label, style = {} }) => (
    <span style={{ ...chipStyle, ...style }}>
        {label}
    </span>
);

export default BasicChip;



// WEBPACK FOOTER //
// ./app/components/Base/Chips/BasicChip.jsx